var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAtividades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6.88889C5.3 2 4 3.3 4 4.88889V19.1111C4 20.7111 5.3 22 6.88889 22H17.1111C18.7111 22 20 20.7 20 19.1111V8L14 2ZM17.1667 8H14V4.83333L17.1667 8ZM17.1111 20H6.88889C6.4 20 6 19.6 6 19.1111V4.88889C6 4.4 6.4 4 6.88889 4H12V10H18V19.1111C18 19.6 17.6 20 17.1111 20Z",
    fill: "#FF5C7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12H8V14H16V12Z",
    fill: "#FF5C7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8H8V10H10V8Z",
    fill: "#FF5C7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H8V18H16V16Z",
    fill: "#FF5C7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAtividades);
export default __webpack_public_path__ + "static/media/ic_atividades.8252bbb46ba432bdf6fac198dc347bed.svg";
export { ForwardRef as ReactComponent };